module.exports = __webpack_public_path__ + "static/media/rin_default1866fb179608dbe879ca0edd06f9a49a.webp";